import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Button } from "reactstrap";
import { useAuth0 } from "@auth0/auth0-react";
// import OpenGameSDK, { LogLevel } from "@ogp/game-sdk";

function formatMilliseconds(ms) {
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((ms % (1000 * 60)) / 1000);

  return `${hours} hours, ${minutes} minutes, and ${seconds} seconds`;
}

const events = [];

const AUTO_START = false;

const Home = () => {
  const { isLoading, isAuthenticated, getAccessTokenSilently, loginWithRedirect, loginWithPopup } = useAuth0();

  const [ogpReady, setOgpReady] = useState(false);

  const [isSet, setIsSet] = useState(true);
  const [ogp, setOgp] = useState(undefined);
  const [_, setEvtCount] = useState(0);
  const [isAuthed, setIsAuthed] = useState(false);
  const [userId, setUserId] = useState('');

  const [state, setState] = useState({
    gameId: '6c2b647d-e47d-47e9-9b73-52b2b6ce8236', //'notifier',
    gameIcon: '',
    useCustomAuth: false,
    playerId: undefined,
    points: 0,
    totalPoints: 0,
    loading: false,
    hasSession: false,
    timeUntilNextClaim: '',
    userRewards: undefined,
    gameRewards: undefined,
    lastEvt: '',
    isAuthed: false,
    useRewardModal: false,
    errorTitle: '',
    errorMessage: '',
    addPoints: 0,
    showPoints: false,
  });

  useEffect(() => {
    if (ogp && isSet)  {
      ogp.onAny((evt, data) => {
        events.push(evt);
        setEvtCount(events.length);
      });
      setIsSet(false);
      ogp.on('OnReady', () => {
        setOgpReady(true);
      });
      ogp.init({gameId: state.gameId, playerId: state.playerId});
      ogp.gameReadyToPlay();
      ogp.on('SessionStarted', () => {
        updateState({hasSession: true});
        setUserId(ogp.playerId);
      });
      ogp.on('LoginSuccess', () => {
        setIsAuthed(true);
      })
    }
  }, [ogp, isSet, state.gameId, state.playerId]);

  useEffect(() => {
    if (isAuthenticated && ogpReady) {
      getAccessTokenSilently({detailedResponse: true})
      .then(({id_token}) => {
        console.log({id_token});
        ogp.setCustomAuthToken(id_token);
      });    
    }
  }, [isAuthenticated, ogpReady]);
  
  useEffect(() => {
    if (!AUTO_START) {
      return;
    }
    if (!ogp) {
      instantiateOGP();
    }
  }, [ogp])

  const instantiateOGP = () => {
    const ui = {
      gameIcon: state.gameIcon,
      usePointsWidget: true
    }
    const props = {ui, useCustomAuth: state.useCustomAuth, /*logLevel: LogLevel.VERBOSE*/ };
    console.log({props})
    // eslint-disable-next-line
    setOgp(new OpenGameSDK(props));
  }

  const onSavePoints = () => {
    // if (state.hasSession) {
      updateState({loading: true})
      ogp.savePoints(state.points).then((res) => {
        console.log(res);
        updateState({
          points: 0,
          loading: false,
        });
      });
    // }
  }

  const updateState = (update) => {
    setState({
      ...state,
      ...update,
    });
  }

  const onInputChange = (key, type) => (evt) => {
    if (type === 'checkbox') {
      updateState({[key]: evt.target.checked});
    } else {
      updateState({[key]: evt.target.value});
    }
  }

  const setPlayerId = () => {
    if (ogpReady) {
      ogp.setPlayerId(state.playerId);
    }
  }

  const onCustomLogin = () => {
    if (ogpReady) {
      loginWithPopup();
      // ogp.startCustomAuth();
      // loginWithRedirect({})
      // ogp.setCustomAuthToken(token);
    }
  }
  
  const addPoint = () => {
    updateState({
      points: state.points + 1,
    })
  }

  const onOpenGameLogin = () => {
    if (ogpReady) {
      ogp.login();
    }
  }

  const getPoints = () => {
    if (state.hasSession) {
      updateState({loading: true});
      ogp.getPoints().then(({points}) => updateState({totalPoints: points, loading: false}));
    }
  }

  const listGameRewards = () => {
    if (state.hasSession) {
      ogp.listGameRewards().then(gameRewards => updateState({gameRewards}));
    }
  }

  const listUserRewards = () => {
    if (state.hasSession) {
      ogp.listUserRewards().then(userRewards => updateState({userRewards}));
    }
  }

  const getTimeUntilNextClaim = () => {
    if (ogpReady) {
      ogp.getTimeUntilNextClaim().then(time => {
        if (time) {
          updateState({
            timeUntilNextClaim: formatMilliseconds(time),
          })
        }
      })
    }
  }

  const listClaimableRewards = () => {
    if (ogpReady) {
      ogp.getClaimableRewards().then(response => {
       console.log(response);
      })
    }
  }

  const onClaim  = () => {
    // @TODO: Need a way to find out if the user is set
    if (isAuthed) {
      ogp.claimRewards(state.useRewardModal);
    }
  }

  const onSendError = () => {
    if (ogpReady) {
      ogp.showError({title: state.errorTitle, message: state.errorMessage});
    }
  }

  const ogpAddPoint = () => {
    ogp.addPoints(state.addPoints);
    updateState({addPoints: 0});
  }

  const toggleShowPoints = () => {
    if (state.showPoints) {
      ogp.ui.hidePoints();
      updateState({showPoints: false});
    } else {
      ogp.ui.showPoints();
      updateState({showPoints: true});
    }
  }

  // console.log({state});

  return (
    <div style={{display: 'flex'}}>
      <div style={{ flex: 1, flexDirection: 'column'}}>
        <label>GameId: </label>
        <input onChange={onInputChange('gameId')} value={state.gameId} disabled={ogpReady} />
        <br />
        <label>Game Icon: </label>
        <input onChange={onInputChange('gameIcon')} value={state.gameIcon} disabled={ogpReady} />
        <br />
        {
          !ogp && (<>
            <label>PlayerId: </label>
            <input onChange={onInputChange('playerId')} value={state.playerId} />
            <br />
          </>)
        }
        <label>Use custom auth: </label>
        <input onChange={onInputChange('useCustomAuth', 'checkbox')} type='checkbox' value={state.useCustomAuth} />
        <br />
        <Button color="primary" onClick={instantiateOGP} disabled={!isSet}>Start Open Game Protocol</Button>
        <br />
        <br />
        <label>UserId: {userId}</label>
        <hr />
        <br />
        <label>PlayerId: </label>
        <input onChange={onInputChange('playerId')} value={state.playerId} disabled={!ogpReady} />
        <Space amount={2} />
        <Button color='primary' onClick={setPlayerId} disabled={!ogpReady}>Set playerId</Button>
        <br/>
        <br/>
        <Button color='primary' onClick={onOpenGameLogin} disabled={!ogpReady || state.useCustomAuth}>Open Game Login</Button>
        <Space amount={2} />
        <Button color='primary' onClick={onCustomLogin} disabled={!ogpReady || !state.useCustomAuth}>Custom Login</Button>
        <br />
        <br />
        <label>Points: {state.points}{' '} </label>
        <Space amount={2} />
        <Button onClick={addPoint}>Add point</Button>
        <Space amount={2} />
        <Button onClick={onSavePoints} disabled={state.loading}>Save points</Button>
        <br />
        <br />
        <label>Add points: </label>
        <input onChange={onInputChange('addPoints')} type="number" value={state.addPoints} />
        <Space amount={2} />
        <Button onClick={ogpAddPoint}>Add point</Button>
        <Space amount={2} />
        <Button onClick={toggleShowPoints}>Show points</Button>
        <br />
        <br />
        <label>Total Points (for the day): {state.totalPoints}</label>
        <Space amount={2} />
        <Button color="primary" onClick={getPoints} disabled={!state.hasSession || state.loading}>Get points</Button>
        <br />
        <br />
        <Button color="primary" onClick={listUserRewards} disabled={!state.hasSession}>List User Rewards</Button>
        <br />
        <label>Response:</label>
        <br />
        {state.userRewards && <label>{JSON.stringify(state.userRewards, null, 2)}</label>}
        <br />
        <br />
        <Button color="primary" onClick={listGameRewards} disabled={!state.hasSession}>List Game Rewards</Button>
        <br />
        <label>Response:</label>
        <br />
        {state.gameRewards && <label>{JSON.stringify(state.gameRewards, null, 2)}</label>}
        <br />
        <br />
        <label>Time until next claim: {state.timeUntilNextClaim}</label>
        <Space amount={2} />
        <br/>
        <Button color="primary" onClick={getTimeUntilNextClaim} disabled={!state.hasSession}>Get time until next claim</Button>
        <br />
        <br />
        <label>list claimable rewards:</label>
        <Space amount={2} />
        <br/>
        <Button color="primary" onClick={listClaimableRewards} disabled={!state.hasSession}>Request</Button>
        <br />
        <br />
        <label>Show Reward List: </label>
        <input onChange={onInputChange('useRewardModal', 'checkbox')} type='checkbox' value={state.useRewardModal} />
        <br />
        <Button color="primary" onClick={onClaim} disabled={!isAuthed || !state.hasSession}>Claim rewards</Button>
        <br />
        <br />
        <label>Transaction ID:</label>
        <input onChange={() => {}} value={''} disabled={true} />
        <Space amount={2} />
        <Button color="primary" onClick={() => {}} disabled={true}>Get Reward status</Button>
        <br />
        <br />
        <label>Error Title:</label>
        <Space amount={2} />
        <input onChange={onInputChange('errorTitle')} value={state.errorTitle} />
        <br />
        <label>Error Message:</label>
        <Space amount={2} />
        <input onChange={onInputChange('errorMessage')} value={state.errorMessage} />
        <br />
        <Button color="primary" onClick={onSendError} disabled={!ogpReady}>Send error</Button>
      </div>
      <div style={{flex: .6}}>
        <label>Events:</label>
        <br/>
        {events.map((evt, i) => <Fragment key={evt+i}><label>{evt}</label><br/></Fragment>)}
      </div>
    </div>
  );
}

const Space = ({amount = 1}) => {
  return new Array(amount).fill(0).map((_,i) => <Fragment key={i}>&nbsp;</Fragment>);
}

export default Home;

